import { __assign, __rest } from "tslib";
import { cloneElement } from 'react';
import { cnTextinput } from '../Textinput';
import './Textinput-Icon.css';
import './_side/Textinput-Icon_side_left.css';
import './_side/Textinput-Icon_side_right.css';
export var TextinputIcon = function (_a) {
    var component = _a.component, side = _a.side, props = __rest(_a, ["component", "side"]);
    return cloneElement(component, __assign(__assign({}, props), { className: cnTextinput('Icon', { side: side }, [component.props.className]) }));
};
